<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="User"
              bc1="App"
              bc2="User"
              bc3="List"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-lg-3 col-sm-12 ">
              <date-picker
                  v-model="startDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="toDate"
                  placeholder="choose starting date"
              ></date-picker>
            </div>
            <div class="col-lg-3 col-sm-12">
              <date-picker
                  v-model="endDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="fromDate"
                  placeholder="choose ending date"
              ></date-picker>
            </div>
            <div class="col-lg-3 col-sm-12">
              <select  class="form-control" v-model="status">
                <option value="">Select Status</option>
                <option value="0">Pending Activation</option>
                <option value="1">Active</option>
                <option value="2">Inactive</option>
                <option value="3">Suspended</option>
                <option value="4">Closed</option>
              </select>
            </div>
          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-lg-4 mb-1 col-sm-12">
              <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
            </div>
            <div class="col-lg-4 mb-1 col-sm-12">
              <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
              <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
            </div>
          </div>

        </div>
        <div class="card">
          <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :filteredData="filteredData"
              @getFullResponse="getFullResponse"
              :show-per-page="true"
              :exportData="exportData"
              :hidePdfExportButton="true"
          />
        </div>
      </div>
    </div>
    <MerchantUpdateStatusModal
        :show="showModal"
        :id="merchantUuid"
        :status="merchantStatus"
        :row="merchantRow"
        :index="merchantIndex"
        vuexKey="users"
        @hide="showModal = false"
    ></MerchantUpdateStatusModal>
  </div>
  <!-- END: Content-->
</template>

<script>

import MerchantUpdateStatusModal from "@/pages/dashboard/merchant/MerchantUpdateStatusModal";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  props: ['propFilters'],
  components: {MerchantUpdateStatusModal,DatePicker},
  mounted() {
    localStorage.setItem("url", "v1/get-merchants");
    this.checkDataInStore('v1/get-merchants')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    if(typeof(this.propFilters) != 'undefined'){

      let filterData = {type: 1}

      if(this.propFilters.currentPage){
        filterData.page = this.propFilters.currentPage
      }

      if(this.propFilters.search){
        this.search = this.propFilters.search
        filterData.search = this.search
      }
      if(this.propFilters.status != ''){
        this.status = this.propFilters.status
        filterData.status = this.status
      }
      if(this.propFilters.startDate){
        this.startDate = this.propFilters.startDate
        filterData.startDate = this.startDate
      }
      if(this.propFilters.endDate){
        this.endDate = this.propFilters.endDate
        filterData.endDate = this.endDate
      }

      this.filteredData = filterData
    }
  },
  data() {
    return {
      exportData: {
        cta: (exportType) => {
          let requestData = {
            type: 1,
            exportAs: exportType,
            reportType: 'merchants',
          }

          if(this.search != ''){
            requestData.search = this.search
          }
          if(this.status != ''){
            requestData.status = this.status
          }
          if(this.startDate){
            requestData.startDate = this.startDate
          }
          if(this.endDate){
            requestData.endDate = this.endDate
          }


          this.downloadReport(requestData)
        }
      },
      currentPage: 1,
      merchantUuid:'',
      merchantStatus:'',
      merchantIndex:'',
      merchantRow:'',
      showModal: false,
      search: "",
      startDate: "",
      endDate: "",
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      url: "v1/get-merchants",
      storageKey: "users",
      isDefault: false,
      status: "",
      filteredData: {type: 1},
      tableHeaderValues: [
        {
          title: "UUID",
          valueKey: "uuid",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;

            } else {
              html = "-";
            }

            return html;
          }
        },
        {
          title: "First Name",
          valueKey: "first_name",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Last Name",
          valueKey: "last_name",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Email",
          valueKey: "email",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Phone",
          valueKey: "phone_number",
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Device",
          valueKey: "device",
          html: true,
          alter: function(value) {
            if (!value) {
              return "-";
            } else {
              let html = `<span class="badge badge-info badge-glow badge-sm">${value}</span>`;
              return html;
            }
          }
        },
        {
          title: "Created Date / Time",
          valueKey: "created_at",
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: (value, row) => {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-glow badge-sm">Active</span>`;
            } else if (value == 2) {
              html = `<span class="badge badge-danger badge-glow badge-sm">Inactive</span>`;
            } else if (value == 3) {
              html = `<span class="badge badge-info badge-glow badge-sm">Suspended</span>`;
            } else if (value == 4) {
              html = `<span class="badge badge-primary badge-glow badge-sm">Closed</span>`;
            } else if (value == 0) {
              html = `<span class="badge badge-dark badge-glow badge-sm">Pending Activation</span>`;
            }

            if(row.status_reason){
              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge badge-light-primary mt-1">${row.status_reason}</div>
                    </div>
                </div>
                `

            }

            // if (row.is_default == 1) {
            //   this.isDefault = true;
            //   html += '<span class="badge badge-secondary ml-1">Default</span>';
            // }

            return html;
          }
        }
      ],
      actions: [
        {
          title: 'Details',
          class: 'btn-primary mt-1  ',
          cta: (row) => {
            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$router.push({name: 'user-detail',params: {id:row.id,propFilters: propFilters}})
          },

        },
        {
          title: 'Status',
          class: 'btn-primary mt-1  ',
          cta: (row,index) => {
            this.merchantUuid = row.id
            this.merchantStatus = row.status
            this.merchantIndex = index
            this.merchantRow = row
            this.showModal = true
          },

        },
        {
          title: 'Groups',
          class: 'btn-primary mt-1  ',
          cta: (row) => {
            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$router.push({name: 'user-groups',params: {id:row.id,propFilters: propFilters}})
          },

        },
        {
          title: 'Profile',
          class: 'btn-primary mt-1',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "userProfileData"
            };
            this.$store.dispatch("set", data);
            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$router.push({ name: "user-profile",params: {propFilters: propFilters} });
          },

        },
        {
          title: 'Logs',
          class: 'btn-primary mt-1  ',
          cta: (row) => {

            let propFilters = {
              search : this.search,
              status : this.status,
              startDate : this.startDate,
              endDate : this.endDate,
            }
            propFilters.currentPage = this.currentPage
            this.$router.push({name: 'get-logs',params: {id:row.uuid,propFilters: propFilters}})
          },

        },
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",

    };
  },
  methods: {
    getFullResponse(response) {
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.currentPage = data.paginationData.currentPage
        // delete this.filteredData.page
      }
    },
    onSubmitFilters() {

      let filterData = {type: 1}


      if(this.search != ''){
        filterData.search = this.search
      }
      if(this.status != ''){
        filterData.status = this.status
      }
      if(this.startDate){
        filterData.startDate = this.startDate
      }
      if(this.endDate){
        filterData.endDate = this.endDate
      }

      this.filteredData = filterData






    },
    clear(){
      this.startDate = null
      this.endDate = null
      this.search = ''
      this.status = ''
      this.filteredData = {type: 1}

    },

  },
};
</script>
